/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @next/next/no-html-link-for-pages */
import styles from "../styles/Home.module.css";
import stylesButton from "../styles/index.module.css";
import Link from "next/link";
import Image from "next/image";

import {
  Heading,
  Box,
  HStack,
  Button,
  ScaleFade,
  Text,
} from "@chakra-ui/react";
import IndexLayout from "../components/index_layout";
import { NextSeo } from "next-seo";
import { languageAlternates } from "../provider/seo";

import React, { useState, useEffect, useRef } from "react";
import SwiperCore, {
  Autoplay,
  Pagination,
  Navigation,
  EffectFade,
} from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

import { RepeatSwiper } from "../components/main_swiper";
import { QuotationModal } from "../components/modal";

// 신규 HomeMarketPC 마켓플레이스, 핫딜 쪽 리스트
import HomeMarketPc from "../components/mypageNew/homeMarketPc";
import HomeMarketTablet from "../components/mypageNew/homeMarketTablet";
import HomeMarketMobile from "../components/mypageNew/homeMarketMobile";

// install Swiper modules
SwiperCore.use([Autoplay, Pagination, Navigation, EffectFade]);
const axios = require("axios").default;

export default function Home() {
  const [list, setList] = useState("market");

  const [marketProduct, setMarketProduct] = useState("");
  const [hotDealProduct, setSHotDealProduct] = useState("");
  const [isLoginCheck, setIsLoginCheck] = useState("");
  const [customSwiper, setCustomSwiper] = useState();
  const [selectedProduct, setSelectedProduct] = useState("");
  const [modalOpen, setModalOpen] = useState(false);

  const quoteExRef = useRef(null);
  const quoteExImg1 = useRef(null);
  const quoteExImg2 = useRef(null);
  const quoteExImg3 = useRef(null);
  const quoteExImg4 = useRef(null);
  const quoteExGoto = useRef(null);
  const [isQuotesExVisible, setIsQuotesExVisible] = useState(false);
  const [isQuotesImg1Visible, setIsQuotesImg1Visible] = useState(false);
  const [isQuotesImg2Visible, setIsQuotesImg2Visible] = useState(false);
  const [isQuotesImg3Visible, setIsQuotesImg3Visible] = useState(false);
  const [isQuotesImg4Visible, setIsQuotesImg4Visible] = useState(false);
  const [isQuotesExGoto, setIsQuotesExGoto] = useState(false);
  // 마켓플레이스 , 핫딜 탭 구분자
  // 1. 페이지 상태 선언 (부모에서 관리)
  const [marketPage, setMarketPage] = useState(1);
  const [hotDealPage, setHotDealPage] = useState(1);
  const [activeTabChild, setActiveTabChild] = useState("market");

  // 2. 공통 데이터 가공 함수 (배열을 페이지와 줄 단위로 분리)
  const getDisplayData = (arr, page, itemsPerPage, itemsPerRow) => {
    if (!arr || arr.length === 0) return { rows: [], totalPages: 0 };

    const totalPages = Math.ceil(arr.length / itemsPerPage);
    const startIndex = (page - 1) * itemsPerPage;
    const currentPageData = arr.slice(startIndex, startIndex + itemsPerPage);

    const rows = [];
    for (let i = 0; i < currentPageData.length; i += itemsPerRow) {
      rows.push(currentPageData.slice(i, i + itemsPerRow));
    }
    return { rows, totalPages };
  };

  // 부모 컴포넌트의 가공 함수
  const getMobileData = (arr, page, itemsPerPage, itemsPerRow) => {
    if (!arr || arr.length === 0) return { rows: [], totalPages: 0 };

    const totalPages = Math.ceil(arr.length / itemsPerPage);

    // 핵심: (page-1)*itemsPerPage 대신 0을 써서 누적 리스트를 만듭니다.
    const currentPageData = arr.slice(0, page * itemsPerPage);

    const rows = [];
    for (let i = 0; i < currentPageData.length; i += itemsPerRow) {
      rows.push(currentPageData.slice(i, i + itemsPerRow));
    }
    return { rows, totalPages };
  };

  // 3. 각 기기별/탭별 데이터 미리 계산
  // PC: 12개씩 2줄 (6열)
  const pcMarket = getDisplayData(marketProduct, marketPage, 12, 6);
  const pcHotDeal = getDisplayData(hotDealProduct, hotDealPage, 12, 6);

  // 태블릿: 8개씩 2줄 (4열)
  const tabletMarket = getDisplayData(marketProduct, marketPage, 8, 4);
  const tabletHotDeal = getDisplayData(hotDealProduct, hotDealPage, 8, 4);

  // 모바일: 10개씩 2줄 (2열)
  const mobileMarket = getMobileData(marketProduct, marketPage, 10, 2);
  const mobileHotDeal = getMobileData(hotDealProduct, hotDealPage, 10, 2);

  const Data = async () => {
    const [hotdealProductRes0, marketplaceListsResult] = await Promise.all([
      axios.get(
        `${process.env.PANDA_API_URL}/api/mallshop/getCategoryWithProductPrice?ca_id=11`
      ),
      axios.get(
        `${process.env.PANDA_API_URL}/api/mallshop/getCategoryWithMarketplace?ca_id=1802`
      ),
    ]);
    setSHotDealProduct(hotdealProductRes0.data.data);
    setMarketProduct(marketplaceListsResult.data.data);
  };

  const clickToggle = async (e) => {
    // 토글을 누를때마다 앞으로 초기화
    // customSwiper.slideTo(0, 500);
    setList(e.target.value);
  };

  const openModal = (productData) => {
    setSelectedProduct(productData);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  useEffect(() => {
    Data();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (entry.target === quoteExRef.current) {
              setIsQuotesExVisible(true);
            }
          }
        });
      },
      {
        threshold: 0.8,
      }
    );

    const observer2 = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (entry.target === quoteExImg1.current) {
              setIsQuotesImg1Visible(true);
            }
          }
        });
      },
      {
        threshold: 0.2,
      }
    );

    const observer3 = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (entry.target === quoteExImg2.current) {
              setIsQuotesImg2Visible(true);
            }
          }
        });
      },
      {
        threshold: 0.3,
      }
    );

    const observer4 = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (entry.target === quoteExImg3.current) {
              setIsQuotesImg3Visible(true);
            }
          }
        });
      },
      {
        threshold: 0.4,
      }
    );

    const observer5 = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (entry.target === quoteExImg4.current) {
              setIsQuotesImg4Visible(true);
            }
          }
        });
      },
      {
        threshold: 0.5,
      }
    );

    const observer6 = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (entry.target === quoteExGoto.current) {
              setIsQuotesExGoto(true);
            }
          }
        });
      },
      {
        threshold: 0.6,
      }
    );

    if (quoteExRef.current) observer.observe(quoteExRef.current);
    if (quoteExImg1.current) observer2.observe(quoteExImg1.current);
    if (quoteExImg2.current) observer3.observe(quoteExImg2.current);
    if (quoteExImg3.current) observer4.observe(quoteExImg3.current);
    if (quoteExImg4.current) observer5.observe(quoteExImg4.current);
    if (quoteExGoto.current) observer6.observe(quoteExGoto.current);

    return () => {
      if (quoteExRef.current) observer.unobserve(quoteExRef.current);
      if (quoteExImg1.current) observer2.unobserve(quoteExImg1.current);
      if (quoteExImg2.current) observer3.unobserve(quoteExImg2.current);
      if (quoteExImg3.current) observer4.unobserve(quoteExImg3.current);
      if (quoteExImg4.current) observer5.unobserve(quoteExImg4.current);
      if (quoteExGoto.current) observer6.unobserve(quoteExGoto.current);
    };
  }, []);

  const SECTIONS = [
    {
      key: "pandaparts",
      title: "전자부품의 모든 것, 판다파츠에서 한 번에",
      description:
        "제조사 3,000+, 전자부품 1,600만+ 실시간 가격비교, 글로벌 소싱까지 쉽고 빠르게 경험해 보세요.",
      tabText: "판다파츠",
      buttonText: "판다파츠 소개",
      href: "/intro",
      bgImage: "../images/main/main_01.webp",
    },
    {
      key: "ondaparts",
      title: "온다N, 전자부품 SaaS 솔루션",
      description: "견적부터 구매·재고관리까지, 하나로 관리하세요.",
      tabText: "온다N",
      buttonText: "온다N 이용하기",
      href: "https://www.ondaparts.com",
      bgImage: "../images/main/main_04.webp",
    },
    {
      key: "marketplace",
      title: "마켓플레이스, 검증된 데이터, 안전한 거래의 시작",
      description:
        "셀러의 검증된 재고 데이터를 기반으로, 신뢰할 수 있는 전자부품 거래 환경을 제공합니다.",
      tabText: "마켓플레이스",
      buttonText: "마켓플레이스 이용하기",
      href: "/seller/event",
      bgImage: "../images/main/main_02.webp",
    },

    {
      key: "hotdeal",
      title: "초특가 전자부품, 단 하루!",
      description: "빠르고 정확한 판다 1DAY 배송, 지금 핫딜 부품을 만나보세요.",
      tabText: "핫딜",
      buttonText: "핫딜 바로가기",
      href: "/parts/mallcategory/11",
      bgImage: "../images/main/main_03.webp",
    },
  ];

  const [activeTab, setActiveTab] = useState("pandaparts");
  const [isAutoSlide, setIsAutoSlide] = useState(true); // 자동 슬라이드 ON/OFF 상태

  // 자동 타이머
  useEffect(() => {
    if (!isAutoSlide) return;

    const sectionKeys = SECTIONS.map((s) => s.key);
    let index = sectionKeys.indexOf(activeTab);

    const interval = setInterval(() => {
      index = (index + 1) % sectionKeys.length;
      setActiveTab(sectionKeys[index]);

      // ✅ 자동 전환 시 버튼 포커스 제거
      if (
        document.activeElement instanceof HTMLElement &&
        document.activeElement.tagName !== "INPUT"
      ) {
        document.activeElement.blur();
      }
    }, 5000); // 5초마다 변경

    return () => clearInterval(interval);
  }, [activeTab, isAutoSlide]);

  const handleTabClick = (key) => {
    setActiveTab(key);
    setIsAutoSlide(false); // 클릭 시 자동 슬라이드 정지
    // 5초 후 자동 슬라이드 다시 켜기
    setTimeout(() => {
      setIsAutoSlide(true);
    }, 5000);
  };

  const renderTab = (key, tabTitle) => (
    <Button
      key={key}
      variant="ghost"
      onClick={() => handleTabClick(key)}
      borderRadius={0}
      className={activeTab === key ? "active_tab" : ""}
    >
      {tabTitle}
    </Button>
  );

  const renderSections = () => (
    <Box w="100%" overflowX="auto" display="flex" justifyContent="center">
      <Box className="section_container">
        {SECTIONS.map((section) => {
          const isActive = activeTab === section.key;
          return (
            <Box
              key={section.key}
              className={`section-item ${isActive ? "active" : "inactive"}`}
              style={{ backgroundImage: `url(${section.bgImage})` }}
              onClick={() => setActiveTab(section.key)}
            >
              <Box
                className={`section_info ${isActive ? "visible" : ""}`}
                position="absolute"
                bottom="20px"
                left="20px"
                bg="rgba(0,0,0,0.5)"
                color="white"
                p={4}
                borderRadius="md"
              >
                <Heading size="md">{section.title}</Heading>
                <Text fontSize="sm" mt={2}>
                  {section.description}
                </Text>
                <Button
                  mt={2}
                  size="sm"
                  as="a"
                  href={section.href}
                  bg="#E53E3E;"
                  target={
                    section.href.startsWith("http") ? "_blank" : undefined
                  }
                  rel={
                    section.href.startsWith("http")
                      ? "noopener noreferrer"
                      : undefined
                  }
                >
                  {section.buttonText}
                </Button>
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );

  const marketTabs = [
    { value: "market", label: "마켓플레이스" },
    { value: "hotDeal", label: "핫딜" },
    // { value: "coupon", label: "이벤트/기획전" },
  ];

  return (
    <IndexLayout>
      {/* 한/영 메인 hreflang 은 메인 두 페이지에만 (control-plane#406) */}
      <NextSeo languageAlternates={languageAlternates("/", "/en")} />
      <Box id="index_wrap">
        <section className="idx_banner idx_banner2">
          <Box>
            <Box w="100%" overflow="hidden">
              {renderSections()}
            </Box>
            <HStack
              spacing={0}
              justify="center"
              bg="#111"
              zIndex={10}
              position="sticky"
              top={0}
              color="#fff"
              borderBottom="1px solid #111"
            >
              {SECTIONS.map((s) => renderTab(s.key, s.buttonText))}
            </HStack>
          </Box>
          {/* <Box className="idx_wrap_bg"></Box> */}
        </section>
        <section className="idx_logo idx_logo2">
          <Box>
            <Box className="idx_logo_lft idx_logo_tp">
              <h3>판다봇 견적</h3>
              <strong>전자부품 견적의 새로운 기준을 경험하세요.</strong>
              <ul>
                <li>
                  <img src="./images/brand/search/digikey_logo.png" />
                </li>
                <li className="logo_arrow">
                  <img src="./images/brand/search/arrow_logo.png" />
                </li>

                <li>
                  <img src="./images/logo/tti.png" />
                </li>
                <li className="logo_mouser">
                  <img src="./images/brand/search/mouser_logo.svg.png" />
                </li>
                <li className="logo_element14">
                  <img src="./images/brand/main/element14_logo.png" />
                </li>
                <li className="logo_onechip">
                  <img src="./images/brand/search/onechip_logo.png" />
                </li>
                <li className="logo_verical">
                  <img src="./images/brand/search/verical_logo.png" />
                </li>
                <li>
                  <img src="./images/logo/future.png" />
                </li>
              </ul>
              <ul>
                <li className="logo_harting">
                  <img src="./images/brand/main/harting_logo.svg.png" />
                </li>
                <li className="logo_apem">
                  <img src="./images/logo/apem.png" />
                </li>
                <li className="logo_texasindustry">
                  <img src="./images/logo/texasinstruments.png" />
                </li>
                <li className="logo_microchip">
                  <img src="./images/logo/microchip.svg.png" />
                </li>
                <li className="logo_inferion">
                  <img src="./images/logo/inferion.png" />
                </li>
                <li className="logo_minicircuits">
                  <img src="./images/logo/minicircuits.png" />
                </li>
                <li className="logo_dfrobot">
                  <img src="./images/brand/search/dfrobot_logo.png" />
                </li>

                <li>
                  <img src="./images/logo/rochester.png" />
                </li>
              </ul>
            </Box>
            <Box className="idx_logo_rt idx_logo_btm">
              <Box>
                <p>
                  <em></em>글로벌 공인 유통사 20+곳 API 실시간 연동
                </p>
                <p>
                  <em></em>제조사 3,000+, 전자부품 1,600만+ 품목 지원
                </p>
                <p>
                  <em></em>자동화된 견적 시스템으로 클릭 한 번에 완료
                </p>
                <p>
                  <em></em>정품 인증을 위한 100% COC(Certificate of Compliance)
                  제공
                </p>
              </Box>
            </Box>
          </Box>
        </section>
        <Box className="idx_goto">
          {/* <p>견적유형을 선택해 주세요.</p> */}
          <Box>
            <Link href="/estimate/quote_request" passHref>
              <div
                className={`${stylesButton.buttonFillPrimary}`}
                style={{ cursor: "pointer" }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={
                    typeof window !== "undefined" && window.innerWidth <= 601
                      ? "16"
                      : "24"
                  }
                  height={
                    typeof window !== "undefined" && window.innerWidth <= 601
                      ? "16"
                      : "24"
                  }
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M20.0484 11.7619L9.54838 23.0119C9.43711 23.1306 9.29023 23.21 9.12992 23.2379C8.9696 23.2659 8.80455 23.2409 8.65966 23.1668C8.51476 23.0928 8.3979 22.9736 8.3267 22.8272C8.2555 22.6809 8.23382 22.5154 8.26494 22.3556L9.63932 15.481L4.23651 13.4522C4.12047 13.4088 4.017 13.3373 3.93533 13.2442C3.85366 13.151 3.79633 13.0391 3.76847 12.9184C3.74062 12.7977 3.7431 12.6719 3.77569 12.5524C3.80828 12.4329 3.86998 12.3233 3.95526 12.2335L14.4553 0.983457C14.5665 0.86471 14.7134 0.785374 14.8737 0.757423C15.034 0.729473 15.1991 0.754423 15.344 0.828509C15.4889 0.902595 15.6057 1.0218 15.6769 1.16813C15.7481 1.31446 15.7698 1.47998 15.7387 1.63971L14.3606 8.52189L19.7634 10.5478C19.8786 10.5915 19.9812 10.6629 20.0622 10.7557C20.1433 10.8485 20.2002 10.9598 20.228 11.0798C20.2558 11.1998 20.2536 11.3248 20.2216 11.4438C20.1897 11.5628 20.1289 11.672 20.0446 11.7619H20.0484Z"
                    fill="white"
                  />
                </svg>
                <span
                  className={
                    typeof window !== "undefined" && window.innerWidth <= 601
                      ? `${stylesButton.white} body3`
                      : `${stylesButton.white} body1`
                  }
                >
                  판다봇 견적요청하기
                </span>
              </div>
            </Link>

            {/* <Link href="/estimate/quote_request_file" passHref>
              <a
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href = "/estimate/quote_request_file";
                }}
              >
                BOM 견적요청
              </a>
            </Link> */}
          </Box>
        </Box>
        <section className="idx_quote">
          <Box>
            <Box
              ref={quoteExRef}
              className={`idx_quote_ex ${isQuotesExVisible ? "animate" : ""}`}
            >
              <p>
                창고에 잠든 재고, <br />
                판다 마켓플레이스에서 <br />
                새로운 판매 기회로 연결하세요.
              </p>
            </Box>
            <Box className="idx_quote_goto">
              <Box
                ref={quoteExImg1}
                className={`idx_quote_goto_img photo01 ${
                  isQuotesImg1Visible ? "animate" : ""
                }`}
              />
              <Box
                ref={quoteExImg2}
                className={`idx_quote_goto_img photo02 ${
                  isQuotesImg2Visible ? "animate" : ""
                }`}
              />
              <Box
                ref={quoteExImg3}
                className={`idx_quote_goto_img photo03 ${
                  isQuotesImg3Visible ? "animate" : ""
                }`}
              />
              <Box
                ref={quoteExImg4}
                className={`idx_quote_goto_img photo04 ${
                  isQuotesImg4Visible ? "animate" : ""
                }`}
              />
              <a
                href="/seller/event"
                ref={quoteExGoto}
                className={`${isQuotesExGoto ? "animate" : ""}`}
              >
                판매자 가이드
                <FontAwesomeIcon icon={faArrowRight} />
              </a>
            </Box>
          </Box>
          {/* <Box className="idx_quote_bg"></Box> */}
        </section>
        {/* 마켓플레이스 핫딜 공간 삽입 */}
        <HomeMarketPc
          marketRows={pcMarket.rows}
          hotdealRows={pcHotDeal.rows}
          marketPage={marketPage}
          setMarketPage={setMarketPage}
          totalMarketPages={pcMarket.totalPages}
          hotDealPage={hotDealPage}
          setHotDealPage={setHotDealPage}
          totalHotDealPages={pcHotDeal.totalPages}
          activeTabChild={activeTabChild}
          setActiveTabChild={setActiveTabChild}
        />
        <HomeMarketTablet
          marketRows={tabletMarket.rows}
          hotdealRows={tabletHotDeal.rows}
          marketPage={marketPage}
          setMarketPage={setMarketPage}
          totalMarketPages={tabletMarket.totalPages}
          hotDealPage={hotDealPage}
          setHotDealPage={setHotDealPage}
          totalHotDealPages={tabletHotDeal.totalPages}
          activeTabChild={activeTabChild}
          setActiveTabChild={setActiveTabChild}
        />
        <HomeMarketMobile
          marketRows={mobileMarket.rows}
          hotdealRows={mobileHotDeal.rows}
          marketPage={marketPage}
          setMarketPage={setMarketPage}
          totalMarketPages={mobileMarket.totalPages}
          hotDealPage={hotDealPage}
          setHotDealPage={setHotDealPage}
          totalHotDealPages={mobileHotDeal.totalPages}
          activeTabChild={activeTabChild}
          setActiveTabChild={setActiveTabChild}
        />
        <section className="idx_ad">
          <Box className={styles.main_ad}>
            <Box className={styles.main_ad_detail}>
              <Box className={styles.main_ad_detail_img}>
                <img src="../images/parts_03.png" width="100%" height="auto" />
              </Box>
              <Box className={styles.main_ad_detail_ex}>
                <span>5만원 이상 구매시 무료배송 </span>
                <span>& 핫딜부품 구매시 당일배송</span>
              </Box>
              <Box className={styles.main_ad_detail_img}>
                <img src="../images/parts_04.png" width="100%" height="auto" />
              </Box>
            </Box>
          </Box>
        </section>
      </Box>
    </IndexLayout>
  );
}
